/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { metaAdCampaignDataStatusSchema } from './MetaAdCampaignDataStatusSchema'

export const metaAdCampaignDataSchema = z.object({
	id: z.string(),
	campaignId: z.string(),
	name: z.string(),
	metaUrl: z.string().nullable(),
	status: metaAdCampaignDataStatusSchema,
	adSet: z.object({
		id: z.string(),
		name: z.string(),
		budget: z.number(),
		ads: z.array(
			z.object({
				id: z.string(),
				name: z.string(),
				status: z.string(),
				metaAdSetId: z.string(),
				updatedAt: z.iso.datetime(),
			}),
		),
		updatedAt: z.iso.datetime(),
	}),
	ads: z.array(
		z.object({
			id: z.string(),
			name: z.string(),
			status: z.string(),
			metaAdSetId: z.string(),
			updatedAt: z.iso.datetime(),
		}),
	).nullable(),
	updatedAt: z.iso.datetime(),
	latestError: z.object({ id: z.string(), errorMessage: z.string(), createdAt: z.iso.datetime() }).nullable(),
})

export type MetaAdCampaignDataSchema = z.infer<typeof metaAdCampaignDataSchema>
